const EDIT_APP_MARKETING_DRAFT_PREFIX = 'admin:appMarketingDraft:edit:'
export const NEW_APP_MARKETING_DRAFT_KEY = 'admin:appMarketingDraft:new'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeTextValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

const normalizeNumberValue = (value, fallbackValue = 0) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 마케팅 작업 기업 폼은 운영자가 다시 입력 비용이 큰 텍스트와 메일발송여부만 sessionStorage에 남긴다.
export const createAppMarketingDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            companyName: normalizeTextValue(params.companyName),
            email: normalizeTextValue(params.email),
            memo: normalizeTextValue(params.memo),
            isEmailSend: normalizeNumberValue(params.isEmailSend, 0),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyAppMarketingDraft = ({ baseParams = {}, draft }) => {
    const normalizedBaseDraft = createAppMarketingDraftPayload({
        params: baseParams,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            companyName: draftParams.companyName === undefined
                ? normalizedBaseDraft.params.companyName
                : normalizeTextValue(draftParams.companyName),
            email: draftParams.email === undefined
                ? normalizedBaseDraft.params.email
                : normalizeTextValue(draftParams.email),
            memo: draftParams.memo === undefined
                ? normalizedBaseDraft.params.memo
                : normalizeTextValue(draftParams.memo),
            isEmailSend: draftParams.isEmailSend === undefined
                ? normalizedBaseDraft.params.isEmailSend
                : normalizeNumberValue(draftParams.isEmailSend, normalizedBaseDraft.params.isEmailSend),
        }
    }
}

export const createEditAppMarketingDraftKey = (marketingId) => `${EDIT_APP_MARKETING_DRAFT_PREFIX}${marketingId}`

export const readAppMarketingDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppMarketingDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppMarketingDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
